var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-bar w-full p-2"},[_c('div',{staticClass:"relative text-md flex justify-center w-full p-2 rounded-md",staticStyle:{"box-shadow":"0 0 .5em rgba(0, 0, 0, 0.3)"},style:({
    backgroundColor: _vm.status=='error'?'#e96e6e':_vm.status=='success'?'#50c53f':_vm.status=='alert'?'#F36711':'#DDDD',
    color: _vm.status=='error'?'#FFF':_vm.status=='success'?'#FFF':'#FFF',
  })},[_c('div',{staticClass:"font-bold absolute right-0 mr-3",on:{"click":function($event){return _vm.$emit('exit')}}},[_vm._v("✖")]),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }